// extracted by mini-css-extract-plugin
export default {"imageWrapper":"uE-z","hovered":"vE-z","hoverImage":"wE-z","mainImage":"xE-z","imageNoBackground":"yE-z","fullSizeImage":"zE-z"};